import { z } from 'zod'

export const NotificationType = z.enum([
  'POST_MENTION',
  'POST_COMMENT_IN_POST_MENTION',
  'COMMENT_MENTION',
  'TASK_MENTION',
  'TASK_COMMENT_IN_TASK_MENTION',
  'AGENDA_NEW_EVENT_NOTIFICATION',
  'AGENDA_EVENT_DELETED_NOTIFICATION',
  'AGENDA_SUBSTITUTION',
  'MANAGER_AGENDA_SUBSTITUTION',
  'RESPONSIBLE_AGENDA_SUBSTITUTION',
  'INCOMING_SESSION',
  'FINISHED_SESSION',
  'NEW_TICKET_ASSIGNED',
  'TICKET_IN_ANALYSIS',
  'TICKET_COMPLETED',
  'NEW_COMPLEMENT_REQUISITION',
  'COMPLEMENT_REQUISITION_DONE',
  'NEW_REVIEW_REQUISITION',
  'POSITIVE_REVIEW_REQUISITION_DONE',
  'NEGATIVE_REVIEW_REQUISITION_DONE'
])

export const RelationalNotification = z.object({
  id: z.string(),
  personaId: z.string(),
  data: z.any(),
  seen: z.boolean(),
  type: NotificationType,
  helpAreaId: z.string().nullish(),
  helpSubAreaId: z.string().nullish(),
  mainDataId: z.string(),
  createdAt: z.string().date()
})

export type RelationalNotification = z.infer<typeof RelationalNotification>
export type NotificationType = z.infer<typeof NotificationType>
